export const bridge = {
  send<TMessage extends Record<string, unknown>>(message: TMessage) {
    const iframe = document.getElementById(
      'pandadoc-iframe',
    ) as HTMLIFrameElement | null

    if (!iframe?.contentWindow) {
      console.warn('Iframe or its contentWindow not available yet')
      return
    }
    iframe.contentWindow.postMessage(message, import.meta.env.VITE_PANDADOC_URL)
  },
  sendMessage<TMessage extends Record<string, unknown>>(message: TMessage) {
    window.parent.postMessage(message, import.meta.env.VITE_SH_URL)
  },

  receive<TMessage extends Record<string, unknown>>(
    callback: (message: TMessage) => void,
  ) {
    window.addEventListener('message', (event: MessageEvent<TMessage>) => {
      const schemaValidation = bridgeSchema.safeParse(event.data)

      if (!schemaValidation.success) return
      callback(event.data)
    })
  },
}
